'use es6';

import { getContacts } from 'pricing-pages-lib/api/ContactsApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
import { isDevPortalSelector } from '../selectors/ScopeSelectors';
export const FetchContactsInCrmRequestTypes = createRequestTypes('CONTACTS_IN_CRM');
export const FetchContactsInCrmActions = createRequestActions(FetchContactsInCrmRequestTypes);
export const fetchNumContactsInCrm = () => (dispatch, getState) => {
  const state = getState();
  const isDevPortal = isDevPortalSelector(state);
  return makeFetchRequest({
    requestActions: FetchContactsInCrmActions,
    fetch: getContacts,
    payload: isDevPortal
  })(dispatch);
};